// Binary search the verse-start marks (is_chunk_mark=false) for the current verse.
// currentTime is always real seconds from the audio element — no speed adjustment needed.
//
// Assumptions:
//   - marks is already sorted ascending by time_seconds (guaranteed by AudioPlayerContext loadAudio)
//   - Returns the verse number of the last mark whose time_seconds <= currentTime
//   - Returns null if marks is empty or not yet loaded
export function findCurrentVerse(marks, currentTime) {
  if (!marks || marks?.length === 0) return null;

  // Filter to verse-start marks only (exclude sub-verse chunk marks)
  const verseMarks = marks?.filter(m => !m?.is_chunk_mark);
  if (verseMarks?.length === 0) return null;

  // If we haven't reached the first verse mark yet, return the first verse
  if (currentTime < verseMarks?.[0]?.time_seconds) {
    return verseMarks?.[0]?.verse;
  }

  // Binary search: find the last mark whose time_seconds <= currentTime
  let lo = 0;
  let hi = verseMarks?.length - 1;
  let result = verseMarks?.[0];

  while (lo <= hi) {
    const mid = (lo + hi) >>> 1; // unsigned right shift avoids negative overflow
    if (verseMarks?.[mid]?.time_seconds <= currentTime) {
      result = verseMarks?.[mid];
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }

  return result ? result?.verse : null;
}
